import { FilterText } from '../types'
import MultipleValuesInput from './MultipleValuesInput'
import TextFilterType from './TextFilterType'

function TextFilterWrapper({
  onFilterTextTypeChange,
  onFilterValueChange
}: {
  onFilterTextTypeChange: (value: FilterText) => void
  onFilterValueChange: (value: string[]) => void
}) {
  return (
    <>
      <MultipleValuesInput
        onChange={(e) => {
          onFilterValueChange(e)
        }}
      />
      <TextFilterType
        onChange={(value) => {
          onFilterTextTypeChange(value)
        }}
      />
    </>
  )
}

export default TextFilterWrapper
